exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-container--social_campaign_detail .field-label[data-v-706647b4]{margin-bottom:14px}", ""]);

// exports
